import type { IntervieweeCard, VillageSummary } from "../domain/contracts";

export type IntervieweeMiniCardMeta = {
  aliasLine: string;
  aliasValue: string;
  displacedLine: string;
  villageLine: string;
  villageValue: string;
};

function pickVillageName(village: VillageSummary): string {
  return village.names.en?.trim() || village.names.ro.trim();
}

export function buildVillageNameLookup(villages: VillageSummary[]): ReadonlyMap<string, string> {
  const byId = new Map<string, string>();

  for (const village of villages) {
    byId.set(village.id, pickVillageName(village));
  }

  return byId;
}

export function buildIntervieweeMiniCardMeta(
  interviewee: IntervieweeCard,
  villageNameLookup: ReadonlyMap<string, string>,
): IntervieweeMiniCardMeta {
  const aliasValue = interviewee.publicPseudonym?.trim() || "Unknown alias";
  const displacedValue = interviewee.displacementYear ?? "Unknown year";
  const villageValue = villageNameLookup.get(interviewee.villageId) ?? "Unknown village";

  return {
    aliasLine: `Alias: ${aliasValue}`,
    aliasValue,
    displacedLine: `Displaced: ${displacedValue}`,
    villageLine: `Village: ${villageValue}`,
    villageValue,
  };
}
